(function () {
    'use strict';

    angular
        .module('tikonApp')
        .component('pfSmsPanelOverview', {
            templateUrl: 'app/components/partial-forms/sms-panel-overview/partial-form.sms-panel-overview.html',
            controller: SmsPanelOverviewComponentController,
            bindings: {
                marketingCampaign: '<',
                onConfirm: '&?',
                onCancel: '&?',
                showActionButtons: '<?'
            }
        });

    SmsPanelOverviewComponentController.$inject = [
        'MarketingCampaignCustom',
        'AlertToastService'
    ];

    function SmsPanelOverviewComponentController(
        MarketingCampaignCustom,
        AlertToastService
    ) {
        var $ctrl = this;

        $ctrl.smsPanelOverview = null;
        $ctrl.loading = false;
        $ctrl.error = false;
        $ctrl.noCustomerSelected = false;

        $ctrl.$onInit = onInit;
        $ctrl.$onChanges = onChanges;
        $ctrl.getSmsPanelOverview = getSmsPanelOverview;
        $ctrl.confirm = confirm;
        $ctrl.cancel = cancel;

        function onInit() {

            if (angular.isUndefined($ctrl.showActionButtons)) {
                $ctrl.showActionButtons = true;
            }

            if ($ctrl.marketingCampaign) {
                getSmsPanelOverview();
            }
        }

        function onChanges(changes) {
            if (
                changes.marketingCampaign &&
                !changes.marketingCampaign.isFirstChange() &&
                changes.marketingCampaign.currentValue
            ) {
                getSmsPanelOverview();
            }
        }

        function getSmsPanelOverview() {
            if (!$ctrl.marketingCampaign) {
                return;
            }

            $ctrl.loading = true;
            $ctrl.error = false;
            $ctrl.noCustomerSelected = false;
            $ctrl.smsPanelOverview = null;

            MarketingCampaignCustom
                .getSmsPanelOverView()
                .save(
                    angular.copy($ctrl.marketingCampaign),
                    onSaveSuccess,
                    onSaveError
                );
        }

        function onSaveSuccess(data) {
            $ctrl.loading = false;
            $ctrl.smsPanelOverview = data;

            $ctrl.noCustomerSelected =
                !data ||
                !data.totalCompanyCustomersCount ||
                data.totalCompanyCustomersCount <= 0;
        }

        function onSaveError(error) {
            $ctrl.loading = false;
            $ctrl.error = true;
            $ctrl.noCustomerSelected = false;

            AlertToastService.error(
                'خطا در دریافت اطلاعات پیامک',
                null,
                null
            );
        }

        function confirm() {
            if (
                !$ctrl.smsPanelOverview ||
                $ctrl.noCustomerSelected
            ) {
                return;
            }

            if ($ctrl.onConfirm) {
                $ctrl.onConfirm({
                    overview: $ctrl.smsPanelOverview
                });
            }
        }

        function cancel() {
            if ($ctrl.onCancel) {
                $ctrl.onCancel();
            }
        }
    }

})();